import type {
  TFilterPayload,
} from '@/creditflowresearch/application/CorporateBondScreener/Sidebar/useCorporateBondScreenerSidebarFilter';

export const endParentsIssuersExcludeWhenEmpty = (filters: TFilterPayload): TFilterPayload => {
  if (filters.excludedIssuerIds.length > 0 || filters.excludedParentIds.length > 0) {
    return filters;
  }

  return {
    ...filters,
    isParentsIssuersExcluded: false,
    issuedByHoldingCompany: filters.issuedByHoldingCompany !== null ? !filters.issuedByHoldingCompany : null,
    issuedByOperatingCompany: filters.issuedByOperatingCompany !== null ? !filters.issuedByOperatingCompany : null,
  };
};
